import {TranslateService} from '@ngx-translate/core';

export enum MoodCategoryType {
  HIGH_ENERGY_UNPLEASANT = 0,
  LOW_ENERGY_UNPLEASANT,
  HIGH_ENERGY_PLEASANT,
  LOW_ENERGY_PLEASANT,
}

export const moodCatTypeMap = (translate: TranslateService) => {
  return {
    [MoodCategoryType.HIGH_ENERGY_PLEASANT]: {
      id: MoodCategoryType.HIGH_ENERGY_PLEASANT,
      label: translate.instant('highEnergyPleasantLbl'),
      name: 'High Energy / Pleasant',
      zone: '#eeba8e',
    },
    [MoodCategoryType.HIGH_ENERGY_UNPLEASANT]: {
      id: MoodCategoryType.HIGH_ENERGY_UNPLEASANT,
      label: translate.instant('highEnergyUnPleasantLbl'),
      name: 'High Energy / Unpleasant',
      zone: '#EFA6C3',
    },
    [MoodCategoryType.LOW_ENERGY_PLEASANT]: {
      id: MoodCategoryType.LOW_ENERGY_PLEASANT,
      label: translate.instant('lowEnergyPleasantLbl'),
      name: 'Low Energy / Pleasant',
      zone: '#7ed1ba',
    },
    [MoodCategoryType.LOW_ENERGY_UNPLEASANT]: {
      id: MoodCategoryType.LOW_ENERGY_UNPLEASANT,
      label: translate.instant('lowEnergyUnPleasantLbl'),
      name: 'Low Energy / Unpleasant',
      zone: '#92C2F6',
    },
  };
};
